import axios from "axios";
import qs from "qs";
import constants from "../constants";
import authenService from "./authenService";
import {EventBus} from "../event-bus.js";
import utils from "./utils";

export default {

  initConfig(config) {
    !config && (config = {});
    !config.paramsSerializer &&
    (config.paramsSerializer = function (params) {
      return qs.stringify(params, {
        arrayFormat: "repeat"
      });
    });

    !config.baseURL && (config.baseURL = constants.SSO_URL_ORG);

    !config.headers && (config.headers = {});

    !config.timeout &&
    (config.timeout = constants.AXIOS_REQUEST_TIMEOUT * 1000);

    let header = config.headers;

    !header["Content-Type"] && (header["Content-Type"] = "application/json");

    let idToken = authenService.getIdToken();
    idToken &&
    (header[constants.HTTP_HEADER_KEY.AUTH_HEADER_STRING] =
      "Bearer " + idToken);
    // console.log("httpSSOService initConfig " + idToken);

    let refreshToken = authenService.getRefreshToken();
    refreshToken && (header[constants.HTTP_HEADER_KEY.REFRESH_TOKEN] = refreshToken);

    let client_id = encodeURIComponent(constants.SSO_CLIENT_ID);
    client_id && (header[constants.HTTP_HEADER_KEY.CLIENT_ID] = client_id);

    return config;
  },

  post(url, data, config) {
    config = this.initConfig(config);
    return axios.post(url, data, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  put(url, data, config) {
    config = this.initConfig(config);
    return axios.put(url, data, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  get(url, config) {
    config = this.initConfig(config);
    return axios.get(url, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  delete(url, config) {
    config = this.initConfig(config);
    return axios.delete(url, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  postFile(url, data, config) {
    (!config) && (config = {});
    (!config.responseType) && (config.responseType = "blob");
    return this.post(url, data, config);
  },

  getFlie(url, config) {
    (!config) && (config = {});
    (!config.responseType) && (config.responseType = "blob");
    return this.get(url, config);
  },

  handleGlobalError(error) {
    if (utils.isErrorResponseMatch(error, constants.HTTP_STATUS.UNAUTHORIZED)) {
      EventBus.$emit(constants.EVENT_BUS.CATCH_ERROR_RESPONSE, {
        error: error
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/httpSSOService.js